import './Text.css';



export function GrimReynolds() {
  return (
    <div class="body">



<div class="row" id="GalleryOne">
  <div class="column">

    <h4>Nineteen Rules of Typography
               <br/><br/>Articles on Iowa 
governor, Kim Reynolds. 
<br/><br/>Printed on Newsprint. Concerning water 
quality, education, 
food assistance, and missing funds.
<br/>
                </h4>
</div>
</div>
<div class="row">

                <br/>
        <img src="GrimReynolds3.jpg">
        </img>
        <img src="GrimReynolds2.jpg">
        </img>
<img alt="Grim Reynolds" src="GrimReynolds1.png">
        </img>
</div></div>





  );
}
